import {
  formatClockOffset,
  parseClockInputToOffsetMs,
  setClockOffset,
  subscribeClockOffset,
  timeNow,
} from '../utils/clock';
import { closeDialog } from '@/stores/dialog';
import { alert } from '@/utils/alertUtils';
import { formatTime } from '@/utils/dataUtils';
import { useEffect, useState } from 'react';

export function ClockAdjustDialog() {
  const [correctTime, setCorrectTime] = useState('');
  const [currentDisplay, setCurrentDisplay] = useState('');
  const [offsetMs, setOffsetMs] = useState(0);
  const offsetLabel = formatClockOffset(offsetMs);

  const handleApply = () => {
    const newOffset = parseClockInputToOffsetMs(correctTime);
    if (newOffset === null) {
      alert({
        title: 'Error',
        message: 'Invalid time value',
      });
      return;
    }
    setClockOffset(newOffset);
    setCorrectTime('');
    closeDialog();
  };

  const handleReset = () => {
    setClockOffset(0);
    setCorrectTime('');
    closeDialog();
  };

  useEffect(() => {
    const update = () => setCurrentDisplay(formatTime(timeNow()));
    update();
    const id = setInterval(update, 1000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => subscribeClockOffset(setOffsetMs), []);

  return (
    <div
      className="stop-scrolling fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      onClick={closeDialog}
    >
      <div
        className="w-full max-w-sm rounded-lg bg-white p-6 shadow-xl"
        onClick={e => e.stopPropagation()}
      >
        <h2 className="mb-4 text-xl font-semibold text-gray-900">
          Adjust Clock
        </h2>

        <div className="mb-4 space-y-1 rounded bg-gray-100 p-3">
          <p className="text-sm text-gray-600">
            Current (adjusted) time:{' '}
            <span className="font-mono font-bold text-gray-900">
              {currentDisplay}
            </span>
          </p>
          <p className="text-sm text-gray-500">
            Offset: <span className="font-mono">{offsetLabel}</span>
          </p>
        </div>

        <div className="mb-4">
          <label
            htmlFor="correct-time"
            className="mb-1 block text-sm font-medium text-gray-700"
          >
            Set correct time (HH:MM)
          </label>
          <input
            id="correct-time"
            type="text"
            value={correctTime}
            onChange={e => setCorrectTime(e.target.value)}
            onKeyDown={e => {
              if (e.key === 'Enter') handleApply();
            }}
            placeholder="e.g. 14:30"
            className="w-full rounded-md border border-gray-300 px-3 py-2 font-mono focus:ring-2 focus:ring-blue-500 focus:outline-none"
            autoFocus
          />
        </div>

        <div className="flex justify-end gap-2">
          <button
            onClick={handleReset}
            className="cursor-pointer rounded-md border border-gray-300 px-4 py-2 font-medium text-gray-700 hover:bg-gray-50"
          >
            Reset
          </button>
          <button
            onClick={closeDialog}
            className="cursor-pointer rounded-md border border-gray-300 px-4 py-2 font-medium text-gray-700 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={handleApply}
            className="cursor-pointer rounded-md bg-blue-600 px-4 py-2 font-medium text-white hover:bg-blue-700"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
}
